/* libs */
import React, { Component } from "react";
import PropTypes from "prop-types";

/* components */
import withForm from "../../../shared/Form";
import { TextInput, SelectInput, CheckBox } from "../../../shared/Forms";
import Experiences from "./Experiences";

/* helpers */
class Form extends Component {
	render() {
		const { themes, experiences, formApi, values } = this.props;
		const navigationTypes = [
			{
				key: "fullScreen",
				value: "fullScreen",
				label: "Full Screen",
			},
			{
				key: "twoColumnGrid",
				value: "twoColumnGrid",
				label: "Two Column Grid",
			},
			{
				key: "threeColumnGrid",
				value: "threeColumnGrid",
				label: "Three Column Grid",
			},
		];

		let themeChoices = [];
		if (themes && themes.length > 0) {
			themeChoices = themes.map(theme => ({
				key: theme.id,
				value: theme.id,
				label: theme.name,
			}));
		}

		return (
			<div>
				<div className="row">
					<div className="col-md-4">
						<TextInput field="title" id="title" placeholder="title" />
						{themes && themes.length > 0 && (
							<SelectInput values={themeChoices} field="themeId" id="themeId" placeholder="theme" />
						)}
						<SelectInput
							values={navigationTypes}
							initialValue={values.kind || "fullScreen"}
							field="kind"
							id="kind"
							placeholder="Navigation type"
						/>
						<CheckBox label="Force Selection" field="forceSelection" id="forceSelection" />
					</div>
					<div className="col-md-8">
						{experiences && experiences.length > 0 && (
							<Experiences values={values} formApi={formApi} experiences={experiences} />
						)}
						{experiences && experiences.length === 0 && <p>Please add an experience first</p>}
					</div>
				</div>
				<div className="btn btn-success" onClick={() => this.props.submitForm(true)}>
					Save Navigation
				</div>
			</div>
		);
	}
}

Form.propTypes = {
	values: PropTypes.object,
	formApi: PropTypes.object,
	themes: PropTypes.array,
	experiences: PropTypes.array,
	submitForm: PropTypes.func,
};

export default withForm(Form);
